import type { SecurityContext } from '../security-context.js'

export type LocalPersistenceMode = 'unavailable' | 'cleartext' | 'encrypted'

export type LocalPersistenceModeCapability = {
    cleartext: boolean
    encrypted: boolean
}

export const LocalPersistenceModeCapabilities = {
    unavailable: {
        cleartext: false,
        encrypted: false
    },
    cleartext: {
        cleartext: true,
        encrypted: false
    },
    encrypted: {
        cleartext: false,
        encrypted: true
    }
} satisfies Record<LocalPersistenceMode, LocalPersistenceModeCapability>

export type LocalPersistencePolicy = {
    authenticationContext: LocalPersistenceMode
    libraryCatalogs: LocalPersistenceMode
    localEncryptionEnrollment: LocalPersistenceMode
    userScopedData: LocalPersistenceMode
}

export const TrustedDeviceLocalPersistencePolicy: LocalPersistencePolicy = {
    authenticationContext: 'cleartext',
    libraryCatalogs: 'cleartext',
    localEncryptionEnrollment: 'cleartext',
    userScopedData: 'cleartext'
}

export const NoLocalPersistencePolicy: LocalPersistencePolicy = {
    authenticationContext: 'unavailable',
    libraryCatalogs: 'unavailable',
    localEncryptionEnrollment: 'unavailable',
    userScopedData: 'unavailable'
}

export function createLocalPersistencePolicy(
    securityContext: SecurityContext
): LocalPersistencePolicy {
    if (securityContext.storageTrust === 'trusted-device') {
        return TrustedDeviceLocalPersistencePolicy
    }

    return NoLocalPersistencePolicy
}
